var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 1.21484V3.54818M3.66667 1.21484V3.54818M0.75 5.88151H11.25M1.91667 2.38151H10.0833C10.7277 2.38151 11.25 2.90384 11.25 3.54818V11.7148C11.25 12.3592 10.7277 12.8815 10.0833 12.8815H1.91667C1.27233 12.8815 0.75 12.3592 0.75 11.7148V3.54818C0.75 2.90384 1.27233 2.38151 1.91667 2.38151Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.04deff051abaa642c71cd06ac735f6b2.svg";
export { ForwardRef as ReactComponent };